import { useLocation } from '@tanstack/react-router';

export function useWorkbenchPathname() {
  return useLocation({ select: (location) => location.pathname });
}
